import {Injectable} from '@angular/core';
import { CryptoService } from '../crypto-services/crypto-services';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

  constructor(private cryptoService: CryptoService) { }

  set(key, value) {
    const cipherObject = this.cryptoService.set(value);
    sessionStorage.setItem(key, cipherObject);
  }

  get(key) {
    const cipherObject = sessionStorage.getItem(key);
    if (cipherObject === null || cipherObject === undefined) {
      return null;
    }
    const plainText = this.cryptoService.get(cipherObject);
    return plainText;
  }
}
